
import { defineComponent } from 'vue';

import Form from '@/shared/mixins/Form';
import { feedbackService } from './FeedbackService';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

export default defineComponent({
  name: 'FeedbackInsert',
  mixins: [Form],
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        message: '',
      },
    };
  },
  validations() {
    return {
      form: {
        message: { required },
      },
    };
  },
  methods: {
    async send() {
      if (!this.validate()) return;

      try {
        await feedbackService.insert({ message: this.form.message });
        this.close();
      } catch (error) {
        this.handleApiError(error);
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
